import moment from "moment";

const VideoInfo = ({ video }) => {
    return (
        <div className="col-md-6">
            <div className="d-flex fs-2 mb-8">
                <div
                    className="text-truncate"
                    style={{ maxWidth: "96%" }}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={video?.video_title}
                >
                    {video?.video_title}
                </div>
                <span
                    className="btn btn-link text-hover-primary p-0"
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={"Copy"}
                    onClick={() => navigator.clipboard.writeText(video?.video_title)}
                >
                    <i className="ki-duotone ki-copy"></i>
                </span>
            </div>

            <div className="d-flex gap-3 mb-4 fs-6 text-gray-500">
                <div className="mt-1" style={{ minWidth: "170px", textAlign: "right" }}>
                    Hash Tag:
                </div>
                <div className="d-flex flex-wrap gap-3">
                    {video.hash_tags?.map((tag, key) => (
                        <span className="badge badge-light-info rounded-pill p-3" key={key}>
                            #{tag.name}
                        </span>
                    ))}
                </div>
            </div>
            <div className="d-flex gap-3 mb-4 fs-6 text-gray-500">
                <div style={{ minWidth: "170px", textAlign: "right" }}>Duration:</div>
                <div className="d-flex flex-wrap gap-3 text-black">{video.duration}</div>
            </div>
            <div className="d-flex gap-3 mb-4 fs-6 text-gray-500">
                <div style={{ minWidth: "170px", textAlign: "right" }}>Products:</div>
                <div className="d-flex flex-wrap gap-3 text-black">{video.products}</div>
            </div>
            <div className="d-flex gap-3 mb-4 fs-6 text-gray-500">
                <div style={{ minWidth: "170px", textAlign: "right" }}>Publish Time:</div>
                <div className="d-flex flex-wrap gap-3 text-black">
                    {moment.unix(video.publish_time).format("YYYY-MM-DD HH:mm:ss")}
                </div>
            </div>
            <div className="d-flex gap-3 mb-4 fs-6 text-gray-500">
                <div style={{ minWidth: "170px", textAlign: "right" }}>May have been promoted:</div>
                <div className="d-flex flex-wrap gap-3 text-black">{video.is_promote ? "Yes" : "No"}</div>
            </div>
        </div>
    );
};

export default VideoInfo;
